"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfServeRepository = void 0;
class SelfServeRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    createSelfServeChargebeeId(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithRetry.post('/self_serve/chargebee_ids', params);
            return data;
        });
    }
    updateSelfServeSubscription(params, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = { Authorization: `Bearer ${token}` };
            const { data } = yield this.clientWithRetry.post('/self_serve/update_subscription', params, { headers });
            return data;
        });
    }
}
exports.SelfServeRepository = SelfServeRepository;
//# sourceMappingURL=SelfServeRepository.js.map